/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_ReasoningInputs */



/**
* | output |
* | --- |
* | "Reasoning" |
*
* @param {Model_Showcase_ReasoningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_reasoning = /** @type {((inputs?: Model_Showcase_ReasoningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_ReasoningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Reasoning")
	return /** @type {LocalizedString} */ ("Reasoning")
});